// extracted by mini-css-extract-plugin
export var active = "MegaMenu-module--active--1cc1f";
export var capitalize = "MegaMenu-module--capitalize--49ba7";
export var cardContainer = "MegaMenu-module--cardContainer--90688";
export var columns = "MegaMenu-module--columns--2da56";
export var fs14 = "MegaMenu-module--fs-14--4928e";
export var fs16 = "MegaMenu-module--fs-16--c5d09";
export var fs20 = "MegaMenu-module--fs-20--d7e70";
export var fs24 = "MegaMenu-module--fs-24--5935d";
export var fs32 = "MegaMenu-module--fs-32--05739";
export var fs40 = "MegaMenu-module--fs-40--ddbbd";
export var fsItalic = "MegaMenu-module--fs-italic--a7748";
export var fsLg = "MegaMenu-module--fs-lg--bfdb3";
export var fsMd = "MegaMenu-module--fs-md--8cad3";
export var fsNormal = "MegaMenu-module--fs-normal--a1c50";
export var fsSm = "MegaMenu-module--fs-sm--d79e5";
export var fsXl = "MegaMenu-module--fs-xl--da15f";
export var fsXs = "MegaMenu-module--fs-xs--bfcec";
export var fsXxl = "MegaMenu-module--fs-xxl--ac101";
export var fsXxs = "MegaMenu-module--fs-xxs--236d8";
export var fwBold = "MegaMenu-module--fw-bold--046bc";
export var fwMedium = "MegaMenu-module--fw-medium--ac18d";
export var fwNormal = "MegaMenu-module--fw-normal--55e40";
export var gotham_bold = "MegaMenu-module--gotham_bold--c5b20";
export var gotham_bold_italic = "MegaMenu-module--gotham_bold_italic--33114";
export var gotham_book = "MegaMenu-module--gotham_book--18ef2";
export var gotham_book_italic = "MegaMenu-module--gotham_book_italic--add48";
export var lowercase = "MegaMenu-module--lowercase--12d9d";
export var megaMenu = "MegaMenu-module--megaMenu--e0d0e";
export var megaMenuItemLink = "MegaMenu-module--megaMenuItemLink--7a78a";
export var megaMenuItemSubTitle = "MegaMenu-module--megaMenuItemSubTitle--56f9b";
export var megaMenuItems = "MegaMenu-module--megaMenuItems--97174";
export var megaMenuSubItemsProducts = "MegaMenu-module--megaMenuSubItemsProducts--1bb78";
export var megaMenuTitle = "MegaMenu-module--megaMenuTitle--e04f5";
export var megaMenuhasCard = "MegaMenu-module--megaMenuhasCard--17447";
export var subMenuActive = "MegaMenu-module--subMenuActive--f92c6";
export var uppercase = "MegaMenu-module--uppercase--870c4";